import {Button, Typography} from '@material-ui/core'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsPageHeader.styles'

type Props = {
  className?: string
  title: string
  onTitleChange?: (title: string) => any
  children?: React.ReactNode
}

function ReportsPageHeader(props: Props) {
  const {className, title, onTitleChange, children} = props
  const classes = useStyles()
  const {p} = useCore('reports', 'components', 'PageHeader')

  function handleTitleChange() {
    if (onTitleChange) onTitleChange('')
  }

  return (
    <header className={`${classes.root} ${className || ''}`} data-testid={p('title')}>
      <div className={classes.title}>
        <Button onClick={handleTitleChange}>
          <Typography>{title}</Typography>
        </Button>
      </div>

      <div className={classes.actions}>{children}</div>
    </header>
  )
}

export default ReportsPageHeader
